export default "__VITE_ASSET__CgqB7TSo__"